module.exports = __webpack_public_path__ + "assets/PentagonDetailed.864e3c296ad07bf040f8f26c9af1ffbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/1x/PentagonDetailed.png
// module id = 549
// module chunks = 0